var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"colored-box",style:({ backgroundColor: _vm.boxColor }),on:{"click":function($event){_vm.$emit('click')}}}),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a880daa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/shared/components/ColoredBox.vue
// module id = dSIX
// module chunks = 1